type SoftphoneConfig = {
  enabled?: boolean
  extension?: unknown
  username?: unknown
  password?: unknown
  displayName?: unknown
}

export type CallCenterEligibility = {
  canDial?: boolean
  santralActive?: boolean
  reason?: string
  softphone?: SoftphoneConfig
} & Record<string, unknown>

const CACHE_MS = 5 * 60 * 1000

type CacheEntry = {
  apiBase: string
  token: string
  expiresAt: number
  data: CallCenterEligibility
}

let cache: CacheEntry | null = null
let inflight: Promise<CallCenterEligibility> | null = null
let inflightKey = ''

export async function fetchCallCenterEligibility(apiBase: string, token: string): Promise<CallCenterEligibility> {
  const cleanApiBase = String(apiBase || '').replace(/\/+$/, '')
  const cleanToken = String(token || '').trim()
  if (!cleanApiBase || !cleanToken) throw new Error('Santral yetkisi için oturum bulunamadı')

  const now = Date.now()
  if (cache && cache.apiBase === cleanApiBase && cache.token === cleanToken && cache.expiresAt > now) {
    return cache.data
  }

  const key = cleanApiBase + ':' + cleanToken
  if (inflight && inflightKey === key) return inflight

  inflightKey = key
  inflight = fetch(cleanApiBase + '/call-center/eligibility', {
    headers: { Authorization: 'Bearer ' + cleanToken },
    cache: 'no-store',
  })
    .then(async (response) => {
      const json = await response.json().catch(() => ({}))
      if (!response.ok || json?.success === false) {
        throw new Error(json?.message || 'Santral yetkisi alınamadı')
      }
      const data = json?.data && typeof json.data === 'object' ? json.data : {}
      cache = {
        apiBase: cleanApiBase,
        token: cleanToken,
        expiresAt: Date.now() + CACHE_MS,
        data: data as CallCenterEligibility,
      }
      return data as CallCenterEligibility
    })
    .finally(() => {
      inflight = null
      inflightKey = ''
    })

  return inflight
}

export function clearCallCenterEligibilityCache() {
  cache = null
  inflight = null
  inflightKey = ''
}
